module.exports = __webpack_public_path__ + "img/Cart.69fcd56d.jpg";